import HeadingWithIcon from '../../Components/Headings/HeadingWithIcon';
import React from 'react';

const ErrorPage = () => {
    return <HeadingWithIcon level={ 2 } type='error'>Sorry, we can't progress your application</HeadingWithIcon>;
};

export default ErrorPage;
